/** @fileoverview Back link + title + subtitle for the Development Report page. */

import { Anchor, Stack, Text, Title } from '@mantine/core'
import { IconChevronLeft } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function DevelopmentReportHeader() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Stack spacing={4}>
      <Anchor
        component='button'
        size='sm'
        onClick={() => navigate('/reports/dashboard')}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 4, alignSelf: 'flex-start' }}
      >
        <IconChevronLeft size={14} />
        {t('development_report.back')}
      </Anchor>
      <Title order={1}>{t('development_report.title')}</Title>
      <Text color='dimmed'>{t('development_report.subtitle')}</Text>
    </Stack>
  )
}
